import { BaseEntity } from "../../baseEntity"

export abstract class PriceCategory extends BaseEntity {

  protected readonly NAME = "name";

  get name(): string { return this.getInternalValue<string>(this.NAME); }
  setName(name: string): this { return this.setInternalValue(this.NAME, name); }
}